import {getAllQuartersOfCity} from "../../gameState/getAllQuartersOfCity";

/**
 * Все кварталы (центральные и базовые) городов, не принадлежащих игроку.
 * Включая нейтральные города — их тоже можно захватывать.
 * Возвращает Map<quarterHexKey, {color, city}>.
 */
export const getEnemyQuarterHexKeys = (citiesCache, currentPlayerColor) => {
  const enemyQuarters = new Map();
  if (!citiesCache) {
    return enemyQuarters;
  }

  Object.entries(citiesCache).forEach(([color, playerCities]) => {
    if (color === currentPlayerColor) {
      return;
    }
    playerCities.forEach((city) => {
      getAllQuartersOfCity(city).forEach((quarterHexKey) => {
        enemyQuarters.set(quarterHexKey, {color, city});
      });
    });
  });

  return enemyQuarters;
};

/**
 * Все кварталы городов самого игрока. Возвращает Map<quarterHexKey, city>.
 */
export const getOwnQuarterHexKeys = (citiesCache, currentPlayerColor) => {
  const ownQuarters = new Map();
  const playerCities = citiesCache?.[currentPlayerColor] || [];

  playerCities.forEach((city) => {
    getAllQuartersOfCity(city).forEach((quarterHexKey) => {
      ownQuarters.set(quarterHexKey, city);
    });
  });

  return ownQuarters;
};
